import { Dispatch } from "react";

import { Grid } from "@mui/material";
import { PhaseSettings } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/PhaseSettingsTab/PhaseSettings";
import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";

interface SettingsTabProps {
  index: number;
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}

export const PhaseSettingsTab = (props: SettingsTabProps) => {
  return (
    <Grid container direction={"column"} rowSpacing={2} mt={2}>
      <PhaseSettings {...props} />
    </Grid>
  );
};
